import { View } from "react-native";

import Image from "$src/core/components/atoms/Image/Image";
import Text from "$src/core/components/atoms/Text/Text";
import useConfig from "$src/core/hooks/use-config";
import useLogo from "$src/core/hooks/use-logo";
import useTranslation from "$src/core/hooks/use-translation";

import $ from "./Footer.web.styles";

const Footer = () => {
  const { name } = useConfig();
  const logo = useLogo();
  const { t } = useTranslation();

  return (
    <View style={$.footer}>
      <View style={$.copyright}>
        <Image
          source={logo}
          style={$.logo}
          alt={t("COMMON/LOGO_ACCESSIBILITY_LABEL")}
          contentFit="contain"
          contentPosition="left center"
          accessibilityRole="image"
          accessibilityLabel={t("COMMON/LOGO_ACCESSIBILITY_LABEL")}
        />
        <Text accessibilityRole="text">
          &copy; {new Date().getFullYear()} {name}. {t("FOOTER/COPYRIGHT")}
        </Text>
      </View>
    </View>
  );
};

export default Footer;
